<!-- /src/components/layouts/TwoColumn-SidebarNarrow.vue -->
<template>
  <div class="layout layout--twoColumn">
    <div class="layout__content">
      <div class="layout__content__columns">
        <aside class="layout__content__columns__left">
          <div class="layout__content__columns__leftInterior">
            <slot name="sidebar"></slot>
          </div>
        </aside>

        <div class="layout__content__columns__right">
          <div class="layout__content__columns__rightInterior">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
}
</script>

<style scoped>

.main-content {
  padding: 0;

  @media(--tablet) {
    padding: 3rem 0 0 var(--itemSpacing);
  }
}

.layout {
  /* min-height: 100vh; */
  display: grid;
  /* user-select: none; */

  &--twoColumn {
    margin-top: 2rem;
  }

  &__content {
    align-self: stretch;
    justify-self: center;
    max-width: var(--desktop-width);
    width: 100%;
    padding: 0 var(--itemSpacing);

    &__columns {

      @media (--tablet) {
        display: grid;
        grid-template-columns: 18rem 1fr;
        height: 100%;
        grid-template-rows: 100%;
      }

      &__left {
        /* grid-column-start: span 0; */

        background-color: rgba(#002f6c, 0.07);
        border-radius: var(--borderRadiusSmall);

        /* @media (--tablet) {
          border-radius: 0;
        } */

        &Interior {
          padding: 2.2rem var(--itemSpacing) 1rem var(--itemSpacing);
        }
      }

      &__right {
        grid-column-start: span 1;

        &Interior {
          padding-top: 2rem;

          @media (--tablet) {
            padding-top: 0;
          }
        }
      }
    }
  }

  &--directory {
    .layout__content__columns {
      @media (--tablet) {
        grid-template-columns: .5fr 1fr;
      }
    }
  }
}
</style>